import React from "react";
import Expansion from "../Expansion";
import Loader from "../HylyLoader";
import { withStyles } from "@material-ui/core";
import { QueryRenderer } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import create_mocked_environment from "../graphql/create_environment";
import * as mockdata from "./mockdata";
import Typography from "../Typography";

const styles = theme => ({
  root: {
    padding: "16px",
    [theme.breakpoints.up("md")]: {
      padding: "24px"
    }
  }
});

const fake_environment = {
  DateTime: () => new Date(),
  Query: (root, params, index) => {
    return {
      categories: () => mockdata.floor_plan
    };
  }
};

function FloorPlan({
  classes,
  environment,
  propertyId,
  handleGalleryImage,
  loading
}) {
  return (
    <div
      className="hidden-scroll-image-uploader"
      style={{ height: "80vh", overflowY: "scroll", width: "100%" }}
    >
      {loading ? (
        <Loader />
      ) : (
          <QueryRenderer
            environment={
              environment || create_mocked_environment(fake_environment)
            }
            query={graphql`
            query floorPlanQuery($propertyId: ID!, $type: String!) {
              categories(propertyId: $propertyId, type: $type) {
                id
                name
                type # Possible values: Sub-org/Org
                createdAt
                hasMore

                floorPlans {
                  id
                  name
                  areaMin
                  areaMax
                  imageName
                  imageUrl
                  imageSize
                  imageDimension
                  thumbnailUrl
                  createdAt
                }
              }
            }
          `}
            variables={{
              propertyId: propertyId || "fake_id",
              type: "floor_plan"
            }}
            render={({ error, props }) => {
              if (Boolean(error)) {
                return <div>{error}</div>;
              } else if (props) {
                if (props.categories.length > 0) {
                  let filterCategories = props.categories.filter(
                    (category, i) => category.floorPlans.length > 0
                  );
                  if (filterCategories.length > 0) {
                    return filterCategories.map((category, i) => (
                      <Expansion
                        key={"floor-plan-" + i}
                        type="floorPlan"
                        categoryId={category.id}
                        section={`${category.name}`}
                        images={category.floorPlans}
                        handleGalleryImage={handleGalleryImage}
                        defaultPadding
                      />
                    ));
                  } else {
                    return (
                      <div className={classes.root}>
                        <Typography type="body1" color="black">
                          No Floor Plan images available.
                      </Typography>
                      </div>
                    );
                  }
                } else {
                  return (
                    <div className={classes.root}>
                      <Typography type="body1" color="black">
                        No Floor Plan images available.
                    </Typography>
                    </div>
                  );
                }
              } else {
                return <Loader />;
              }
            }}
          />
        )}
    </div>
  );
}

export default withStyles(styles)(FloorPlan);
